<template>
  <div class="ibox mt-3">
    <div class="ibox-title pt-3">
      <h5><strong>Serviços</strong></h5>
    </div>

    <div class="ibox-content" v-if="!loaded">
      <h3>Carregando...</h3>
    </div>

    <div class="ibox-content" v-else>
      <!-- Search -->
      <div class="row mt-4">
        <div class="col-md-8">
          <input
            class="input form-control"
            v-model="generic"
            placeholder="Pesquisar por nome do serviço"
            @input="page = 1"
          >
        </div>

        <div class="col-md-2">
          <button class="btn btn-outline" @click="save" :disabled="!changeServices">
            Salvar
          </button>
        </div>
      </div>

      <template v-for="service in paginationServices">
        <Service
          :key="service.name"
          :service="service"
          :credentials="credentials"
        />

        <hr :key="`hr_${service.name}`">
      </template>

      <!-- Pagination -->
      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination
            v-model="page"
            :total-count="selectedServices.length"
            :total-pages="totalPages"
            @pagination="pagination"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import EntityProxy from '@/models/EntityProxy'
import GlobalLoading from '@/mixins/GlobalLoading'
import Pagination from '@/components/shares/specialTag/Pagination'
import Service from '@/components/vehicles/container/Service'
import Sorter from '@/models/Sorter'

export default {
  components: { Pagination, Service },
  computed: {
    appNames() {
      return this.accountApps.map(aa => aa.name)
    },
    changeServices() {
      const current = JSON.stringify(this.currentServices)
      const old = this.backupServices

      return current !== old
    },
    selectedServices() {
      const services = this.currentServices.filter(s => this.appNames.includes(s.appName))
      const generic = this.generic.toLowerCase()
      if (!generic)
        return services

      return services.filter(s => {
        const words = [s.friendlyName, s.name].flat().filter(w => w).map(w => w.toLowerCase())
        return words.some(word => word.includes(generic))
      })
    },
    paginationServices() {
      const start = (this.page - 1) * this.perPage
      return this.selectedServices.slice(start, start + this.perPage)
    },
    totalPages() {
      return Math.ceil(this.selectedServices.length / this.perPage)
    },
  },
  created() {
    this.loadData()
  },
  data: () =>({
    scrapingServices: [],
    credentials: [],
    currentServices: [],
    backupServices: '',
    loaded: false,
    generic: '',
    page: 1,
    perPage: 5
  }),
  methods: {
    pagination(page) {
      this.page = page
    },
    async loadData() {
      await this.fetchCredentials()
      await this.fetchScrapingServices()
      this.buildCurrentServices()
      this.loaded = true
    },
    fetchScrapingServices() {
      const params = {
        meta: false,
        per_page: 10000,
        query: {
          app_name: this.appNames
        }
      }

      return this.axios.get('maestro/scraping_services', { params })
        .then(response => this.scrapingServices = EntityProxy.build(response.data))
        .catch(e => this.$notify.addError(e))
    },
    fetchCredentials() {
      return this.axios.get('credentials?meta=false&per_page=10000')
        .then(response => this.credentials = EntityProxy.build(response.data))
        .catch(e => this.$notify.addError(e))
    },
    buildCurrentServices() {
      const currentServices = []
      this.scrapingServices.forEach(scrapingService => {
        currentServices.push(this.buildServiceClone(scrapingService))
      })

      this.currentServices = Sorter.sortBy(currentServices, 'friendlyName', { sensitivity: false })
      this.backupServices = JSON.stringify(this.currentServices)
    },
    buildServiceClone(scrapingService) {
      const service = this.vehicle.services[scrapingService.name] || {}

      return {
        name: scrapingService.name,
        appName: scrapingService.appName,
        friendlyName: scrapingService.friendlyName,
        validateFields: scrapingService.validateFields,
        enable: service.enable || false,
        credentialId: service.credentialId || null,
        active: scrapingService.enable !== false
      }
    },
    save() {
      const newServices = {}
      const selectedServices = this.currentServices.filter(s => s.enable)

      selectedServices.forEach(service => {
        if (service.credentialId)
          newServices[service.name] = { enable: true, credential_id: service.credentialId }
        else
          newServices[service.name] = { enable: true }
      })

      this.openGlobalLoad()
      this.axios.put(`vehicles/${this.vehicle.id}`, { services: newServices })
        .then(() => this.$notify.add('Veículo salvo com Sucesso!'))
        .then(() => this.vehicle.services = EntityProxy.build(newServices))
        .then(() => this.buildCurrentServices())
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    }
  },
  name: 'Services',
  mixins: [GlobalLoading],
  props: {
    accountApps: { required: true, type: Array },
    vehicle: { required: true, type: Object },
  },
}
</script>

<style scoped>

</style>